import { Component, Input } from '@angular/core';

@Component({
    selector: 'gl-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    standalone: false
})
export class IconComponent {
  @Input() public name: string;
}
